import React from "react";

const NoImageController = ()=>{
    return(
        <div className="no-image-wrapper">
            <span>No Image</span>
        </div>
    );
}
export default NoImageController;